import { render } from "./OrderDetailsDialog.vue?vue&type=template&id=4b062b1f&scoped=true"
import script from "./OrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDialog.vue?vue&type=script&lang=js"

import "./OrderDetailsDialog.vue?vue&type=style&index=0&id=4b062b1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b062b1f"]])

export default __exports__